import Component from "vue-class-component";
import Vue from "vue";
import useParamsUserId from "@/hooks/useParamsUserId";

type HookType = ReturnType<typeof useParamsUserId>;

@Component({
  name: "WithParamsUserId",
  setup() {
    const { paramsUserId } = useParamsUserId();
    return {
      paramsUserId,
    };
  },
})
export default class WithParamsUserId extends Vue {
  public paramsUserId!: HookType["paramsUserId"]["value"];
}
